import Vue from "vue";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import axios from "axios";
import i18n from "./translations/i18n";
import "./font-awesome/font-awesome.js";
import VueSimpleAlert from "vue-simple-alert";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import underscore from "vue-underscore";
import PrettyCheckbox from "pretty-checkbox-vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// NOTE: Vee Validate
import { ValidationObserver, ValidationProvider, extend, configure } from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import fr from "vee-validate/dist/locale/fr.json";
import * as rules from "vee-validate/dist/rules";
Object.keys(rules).forEach(rule => {
  if (i18n.locale === "fr") {
    extend(rule, {
      ...rules[rule], // add the rule
      message: fr.messages[rule], // add its message
    });
  } else if (i18n.locale === "en") {
    extend(rule, {
      ...rules[rule], // add the rule
      message: en.messages[rule], // add its message
    });
  }
});

configure({
  classes: {
    // valid: "is-valid",
    // invalid: "is-invalid",
    // dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
    // ...
  },
});

import("./registerServiceWorker");

import App from "./App";
import router from "./router/router";
import store from "./store/store";
import "./registerServiceWorker";
import mixins from "./mixins/mixins";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Vue.http = Vue.prototype.$http = axios;
Vue.config.productionTip = false;

// register v-select globally
Vue.component("v-select", vSelect);
// register v-multiselect globally
Vue.component("v-multiselect", Multiselect);
// Register Bootstrap Vue plugin
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);

const vueMoment = require("vue-moment");
const moment = require("moment-timezone");
Vue.use(vueMoment, {
  moment,
});

import Loader from "@/components/Snippets/Loader";
Vue.component("appLoader", Loader);

import LoaderOverlay from "@/components/Snippets/LoaderOverlay";
Vue.component("appLoaderOverlay", LoaderOverlay);

console.log(new Date());

Vue.use(VueSimpleAlert);
Vue.use(underscore);
Vue.use(PrettyCheckbox);

// Vee Validate
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// register mixins globally
Vue.mixin(mixins);

Sentry.init({
  Vue,
  dsn: "https://0e81c344fc1840cebe8da9a33433e3b7@o1072067.ingest.sentry.io/6070639",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost" /** add others .. */],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  logErrors: true,
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount("#app");

// change other locale
i18n.locale = "fr";
